<ng-container *ngIf="adjustment.projectInvoices?.length > 0">
  <mat-card class="top-card mat-elevation-z0 overflowHidden">
    <span *ngIf="showTitle">{{
      project?.collaborative
        ? 'Prijsberekeningen gezamenlijke opdracht'
        : 'Afwijkende prijsberekeningen'
    }}</span>
    <div class="upper-space">
      <mat-checkbox
        [(ngModel)]="divergentPricesOnly"
        (ngModelChange)="divergentPricesOnlyChanged()"
      >
        <span>Enkel onderstaande prijs in rekening brengen</span>
      </mat-checkbox>
    </div>
    <div
      *ngFor="let invoice of adjustment.projectInvoices; let count = count"
      class="upper-space"
    >
      <ip-board-adjustment-company-invoice
        [adjustmentInvoice]="invoice"
        [multiple]="count > 1"
        [showSave]="showSave"
        [savingLines]="savingLines"
        (save)="save.emit()"
        (saveLines)="saveLines.emit()"
      ></ip-board-adjustment-company-invoice>
    </div>
  </mat-card>
</ng-container>
